module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eEKLW"))).then(() => parcelRequire('d0iPb'));